import { createRouter as createTanStackRouter } from '@tanstack/react-router'
import { routeTree } from './routeTree.gen'

import type { ReactNode } from 'react'
import { setupRouterSsrQueryIntegration } from '@tanstack/react-router-ssr-query'
import TanstackQueryProvider, {
  getContext,
} from './integrations/tanstack-query/root-provider'
import { RouteError, RoutePending } from './components/RouteBoundary.tsx'

export function getRouter() {
  const context = getContext()

  const router = createTanStackRouter({
    routeTree,
    context,
    scrollRestoration: true,
    defaultPreload: 'intent',
    defaultPreloadStaleTime: 0,
    // The same two components the root route uses, applied at every depth.
    // Without these, only the root match has a boundary, so a child
    // loader's throw unwinds past the chrome and takes the sidebar with
    // it; with them the broken page is replaced and the nav stays usable.
    defaultErrorComponent: RouteError,
    defaultPendingComponent: RoutePending,
    Wrap: ({ children }: { children: ReactNode }) => (
      <TanstackQueryProvider queryClient={context.queryClient}>
        {children}
      </TanstackQueryProvider>
    ),
  })

  setupRouterSsrQueryIntegration({ router, queryClient: context.queryClient })

  return router
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof getRouter>
  }
}
